import { Routepage } from './component/Routepage';

function App() {
  return (
      <Routepage/>
   
  );
}

export default App;






